import formatStat, { mapValue, renderStat } from '@utils/formatStat'
import capitalize from '@utils/capitalize'
import { size } from '@styles/theme'

import { DialogFormGroup, Section, SectionHeading } from './SharedFormComponents'
import { EnumValueCheckbox } from '@elements/form_elements/EnumValueCheckbox'
import { SingleEnumRadio } from '@elements/form_elements/SingleEnumRadio'
import { DialogInput } from '@elements/dialog_inputs/DialogInput'
import { PiInfoBold } from 'react-icons/pi'

const labelStyles = {
  display: 'flex',
  flexWrap: 'nowrap',
  flexShrink: 0,
  width: size(15),
  marginRight: size(-4),
}

const sexualityStyles = {
  ...labelStyles,
  width: size(20),
  marginRight: size(-4), 
}

const GenderRadioList = ({ state, handleExtendedChange }) => {
  const vals = ['gender_unspecified', 'male', 'female', 'nonbinary']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <SingleEnumRadio
          key={i}
          slots={{ label: { style: labelStyles } }}
          onChange={handleExtendedChange}
          state={state}
          name='gender'
          label={capitalize(formatStat('gender', val)) || 'Unspecified'}
          value={val}
        />
      ))}
    </DialogFormGroup>
  )
}

const ExpressionCheckList = ({ state, handleEnumChange }) => {
  const vals = ['bear', 'bro', 'clean_cut', 'college', 'corporate', 'cub', 'curious', 'daddy', 'discreet', 'drag', 'emo', 'fairie', 'femme', 'female_to_male', 'gaymer', 'geek', 'goth', 'guy_next_door', 'intellectual', 'intersex', 'jock', 'leather', 'masc', 'male_to_female', 'nudist', 'otter', 'poz', 'punk', 'pup', 'rugged', 'skater', 'son', 'sporty', 'swinger', 'trans', 'trucker', 'twink', 'uniformed', 'u_plus', 'wolf']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <EnumValueCheckbox
          key={i}
          slots={{ label: { style: labelStyles } }}
          state={state}
          property='expression'
          name={val}
          label={capitalize(mapValue(val.replaceAll('_', ' ')))}
          onChange={handleEnumChange}
        />
      ))}
    </DialogFormGroup>
  )
}

const SexualityRadioList = ({ state, handleExtendedChange }) => {
  const vals = ['sexuality_unspecified', 'straight', 'straight_curious', 'bi_curious', 'bisexual', 'gay', 'sexuality_other']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <SingleEnumRadio
          key={i}
          slots={{ label: { style: sexualityStyles } }}
          onChange={handleExtendedChange}
          state={state}
          name='sexuality'
          label={capitalize(formatStat('sexuality', val)) || 'Unspecified'}
          value={val}
        />
      ))}
    </DialogFormGroup>
  )
}

const PositionRadioList = ({ state, handleExtendedChange }) => {
  const vals = ['position_unspecified', 'dom_top', 'sub_top', 'top', 'verse_top', 'verse', 'verse_bottom', 'bottom', 'dom_bottom', 'sub_bottom', 'side', 'position_other']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <SingleEnumRadio
          key={i}
          slots={{ label: { style: labelStyles } }}
          onChange={handleExtendedChange}
          state={state}
          name='position'
          label={capitalize(formatStat('position', val)) || 'Unspecified'}
          value={val}
        />
      ))}
    </DialogFormGroup>
  )
}

const IdentityFormSection = ({ state, handleExtendedChange, handleEnumChange, handleClear }) => {

  return (
    <Section style={{ paddingTop: size(2) }}>
      <SectionHeading>
        Identity
      </SectionHeading>
      <DialogInput
        label='Gender'
        onClear={() => handleClear('gender', 'gender_unspecified')}
        displayValue={state['gender'] && renderStat('gender', state)}>
        <GenderRadioList state={state} handleExtendedChange={handleExtendedChange} />
      </DialogInput>
      <DialogInput
        label='Expression'
        notice={<><PiInfoBold />&nbsp;select up to 3</>}
        onClear={() => handleClear('expression', new Set())}
        displayValue={state['expression'] && renderStat('expression', state)}>
        <ExpressionCheckList state={state} handleEnumChange={handleEnumChange} />
      </DialogInput>
      <DialogInput
        label='Sexuality'
        onClear={() => handleClear('sexuality', 'sexuality_unspecified')}
        displayValue={state['sexuality'] && renderStat('sexuality', state)}>
        <SexualityRadioList state={state} handleExtendedChange={handleExtendedChange} />
      </DialogInput>
      <DialogInput
        label='Position'
        onClear={() => handleClear('position', 'position_unspecified')}
        displayValue={state['position'] && renderStat('position', state)}>
        <PositionRadioList state={state} handleExtendedChange={handleExtendedChange} />
      </DialogInput>
    </Section>
  )
}

export { IdentityFormSection }
